import CampaignBookingApplication from './CampaignBookingApplication';

export default CampaignBookingApplication;
